import { getPaymentFrequencyAndDivisor } from '@ratehub/mtg-common';


function calculateTotalInvestmentValue({
    initialInvestment,
    additionalContributions,
    additionalContributionsFrequency,
    compoundInterestRate,
    compoundFrequency,
    timeHorizon,
}) {
    if (initialInvestment == undefined || compoundInterestRate == undefined
        || compoundFrequency == undefined || timeHorizon == undefined) {
        return null;
    }

    // total investment value calculation (see ticket fit-2740 for full formula)
    const mappedCompoundFrequency = getPaymentFrequencyAndDivisor(compoundFrequency.toLowerCase()).frequency;
    const adjustedCompoundInterestRateInPercent = compoundInterestRate / (mappedCompoundFrequency * 100);

    const initialInvestmentCompounder
        = Math.pow(1 + adjustedCompoundInterestRateInPercent, mappedCompoundFrequency * timeHorizon);
    const compoundedInitialInvestment = initialInvestment * initialInvestmentCompounder;

    const mappedAdditionalContributionsFrequency
        = getPaymentFrequencyAndDivisor(additionalContributionsFrequency.toLowerCase()).frequency;
    const payment = additionalContributions * (mappedAdditionalContributionsFrequency / mappedCompoundFrequency);
    const compoundedAdditionalContributions = payment * (initialInvestmentCompounder - 1) / adjustedCompoundInterestRateInPercent;

    return (compoundedInitialInvestment + compoundedAdditionalContributions).toString();
}

export default calculateTotalInvestmentValue;
